module.exports = {
	howler:	[
	],
	pixi: [
	]
};




//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 113
// module chunks = 0